import React from 'react';
import ModuleView from './ModuleView.js'

function ContentModulesView(props) {
    return (
        <div>
            {props.modules.map((module) => <ModuleView key={module.id} module = {module} parentTrackSlug={props.parentTrackSlug}/>)}
        </div>
    )
}

export default ContentModulesView;